const fetchWithCredentials = (url, options = {}) => {
  return fetch(url, {
    ...options,
    credentials: 'include',
    headers: {
      ...options.headers,
      'Content-Type': 'application/json'
    }
  });
};

export const getCurrentUser = async () => {
  try {
    const response = await fetchWithCredentials('/auth/current_user');
    if (!response.ok) throw new Error('认证失败');
    return await response.json();
  } catch (error) {
    console.error('获取用户信息失败:', error);
    return { user: null };
  }
};

export const loginWithGoogle = () => {
  window.location.href = '/auth/google';
};

export const logout = async () => {
  try {
    const response = await fetchWithCredentials('/auth/logout');
    if (!response.ok) throw new Error('退出失败');
    // 无论返回结果如何，退出后跳转至根域名
    await response.json().catch(() => {});
    window.location.href = '/';
  } catch (error) {
    console.error('退出失败:', error);
    // 若调用失败，也强制跳转以清除前端状态
    window.location.href = '/';
  }
};